import { useState } from "react";

import iPlusBlack from "../../assets/images/100-circle-plus-black.svg";
import iEyeHide from "../../assets/images/100-eye-hide.svg";
import iEyeShow from "../../assets/images/100-eye-show.svg";
import iLock from "../../assets/images/100-lock.svg";
import iMusicBlue from "../../assets/images/100-music-blue.svg";
import iNoiseBlue from "../../assets/images/100-noise-blue.svg";
import iPenBlue from "../../assets/images/100-pen-blue.svg";
import iPlay from "../../assets/images/100-play.svg";
import iSilent from "../../assets/images/100-silent.svg";
import iUnlock from "../../assets/images/100-unlock.svg";
import avatar4 from "../../assets/images/avatar2.png";
import iImg from "../../assets/images/mic.svg";
import iWindow from "../../assets/images/os-windows-disable.svg";
import iTransition from "../../assets/images/transition.svg";

const Timeline = () => {
  const [loadingPage, setLoadingPage] = useState(true);

  setTimeout(() => {
    setLoadingPage(false);
  }, 1000);

  return (
    <div className="fg-timeline-container">
      {loadingPage ? (
        <div className="loading-timeline loading-animation">
          <div className="loading-w-40-40-50p" />
        </div>
      ) : (
        <>
          <input type="range" min="0" max="100" className="fg-timeline-slider" />
          <div className="fg-timeline-items">
            <div className="fg-timeline-row">
              <div className="fg-timeline-item fg-timeline-blue fg-timeline-media m-l-60">
                <img alt="" src={iImg} className="i-12" />
              </div>
              <div className="fg-timeline-item fg-timeline-orange flex-grow-1">
                <img alt="" src={iWindow} className="i-12" />
                <span className="C1-SemiBold p-l-7 p-r-6"> Screnn 1 </span>
                <span className="circle-count C2-SemiBold i-12"> 3 </span>
              </div>
              <div className="fg-timeline-item fg-timeline-transition">
                <img alt="" src={iTransition} className="i-12" />
              </div>
              <div className="fg-timeline-item fg-timeline-red flex-grow-1">
                <img alt="" src={iWindow} className="i-12" />
                <span className="C1-SemiBold p-l-7 p-r-6"> Screnn 1 </span>
                <span className="circle-count C2-SemiBold i-12"> 10 </span>
              </div>
              <div className="fg-timeline-item fg-timeline-transition">
                <img alt="" src={iTransition} className="i-12" />
              </div>
              <div className="fg-timeline-item fg-timeline-cyan flex-grow-1">
                <img alt="" src={iWindow} className="i-12" />
                <span className="C1-SemiBold p-l-7 p-r-6"> Screnn 1 </span>
                <span className="circle-count C2-SemiBold i-12"> 8 </span>
              </div>
              <div className="fg-timeline-item">
                <img alt="" src={iPlusBlack} className="i i-30" />
              </div>
            </div>
            <div className="fg-timeline-row">
              <div className="fg-timeline-item fg-timeline-controllers">
                <img alt="" src={iUnlock} className="i-16" />
                <img alt="" src={iSilent} className="i-16" />
                <img alt="" src={iEyeHide} className="i-16" />
              </div>
              <div className="fg-timeline-item fg-timeline-blue" style={{ width: "200px", marginLeft: "140px" }}>
                <img alt="" src={iPenBlue} className="i-12" />
              </div>
            </div>
            <div className="fg-timeline-row">
              <div className="fg-timeline-item fg-timeline-controllers">
                <img alt="" src={iLock} className="i-16" />
                <img alt="" src={iPlay} className="i-16" />
                <img alt="" src={iEyeShow} className="i-16" />
              </div>
              <div className="fg-timeline-item fg-timeline-comments" style={{ width: "30%", margin: "0 20px" }}>
                <img alt="" src={iNoiseBlue} className="i-12" />
                <div className="flex">
                  <div className="circle-users p-r-4">
                    <img alt="" src={avatar4} className="i-20" />
                    <img alt="" src={avatar4} className="i-20" />
                    <img alt="" src={avatar4} className="i-20" />
                  </div>
                  <div className="C1-SemiBold align-center h-20">+12</div>
                </div>
              </div>
              <div className="fg-timeline-item fg-timeline-comments" style={{ width: "200px" }}>
                <img alt="" src={iNoiseBlue} className="i-12" />
                <div className="flex">
                  <div className="circle-users p-r-4">
                    <img alt="" src={avatar4} className="i-20" />
                    <img alt="" src={avatar4} className="i-20" />
                    <img alt="" src={avatar4} className="i-20" />
                  </div>
                </div>
              </div>
            </div>
            <div className="fg-timeline-row">
              <div className="fg-timeline-item fg-timeline-controllers">
                <img alt="" src={iLock} className="i-16" />
                <img alt="" src={iPlay} className="i-16" />
                <img alt="" src={iEyeShow} className="i-16" />
              </div>
              <div className="fg-timeline-item fg-timeline-music" style={{ width: "310px", marginLeft: "220px" }}>
                <img alt="" src={iMusicBlue} className="i-12" />
                <div className="fg-timeline-wava" />
              </div>
              <div className="fg-timeline-item fg-timeline-music" style={{ width: "170px", marginLeft: "20px" }}>
                <img alt="" src={iMusicBlue} className="i-12" />
                <div className="fg-timeline-wava" />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Timeline;
